import React from 'react';
import { getApiUrl } from '../config/api';

// Material UI
import Grid from "@mui/material/Grid";
import ContactsIcon from '@mui/icons-material/Contacts';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';

// Local
import '../css/Message.css';
import { PersonIcon } from './PersonIcon';

const MessageBubbles = React.memo(function MessageBubbles(props) {
  const formattedMessages = props.messageTexts.map((message, index) =>
    <p key={`${message.message_id}-${index}`} className={props.className} id={"message_id_" + message.message_id}>{message.body}</p>
  );
  return (
    <div type="message">
      {formattedMessages}
    </div>
  );
});

function prepareInitials(obj, number) {
	if (obj === undefined) {
		if (number == null) {
			return "?";
		}
		return number.slice(-2);
	}
	else {
		return obj;
	}
}

const MessageGroup = React.memo(function MessageGroup(props) {
  const messageClass = props.owner ? "send" : "receive";
  const iconClass = messageClass + "-icon";
  const rowJustify = props.owner ? "flex-end" : "flex-start";

  const messageList = React.useMemo(() => {
    return props.messages ? props.messages.map((message) => {
      if (message.attachment_name != null) {
        const url = getApiUrl("/attachments/" + message.id + "/" + message.attachment_name);
        if (message.attachment_name.endsWith(".vcf")) {
          return {"body":<div><a href={url}><ContactsIcon/></a></div>, "message_id":message.message_id};
        }
        else if (/(?:mp3)|(?:wav)|(?:m4a)|(?:ogg)$/i.test(message.attachment_name)) {
          return {"body":<div>{message.body} <audio src={url} className="audio_attachment" controls style={{width: '300px', height: '32px'}}/></div>, "message_id":message.message_id};
        }
        else if (/(?:amr)$/i.test(message.attachment_name)) {
          return {"body":<div>{message.body} <a href={url} download><RecordVoiceOverIcon/> Download Audio</a></div>, "message_id":message.message_id};
        }
        else if (/(?:mp4)|(?:3gp)|(?:mov)|(?:avi)|(?:webm)$/i.test(message.attachment_name)) {
          return {"body":<div>{message.body} <video src={url} className="video_attachment" controls style={{maxWidth: '300px', maxHeight: '200px'}}/></div>, "message_id":message.message_id};
        }
        else{
          return {"body":<div>{message.body} <a href={url}><img src={url} className="img_attachment" alt="Attachment"/></a></div>, "message_id":message.message_id};
        }
      }
      return {"body":message.body, "message_id":message.message_id};
    }) : [];
  }, [props.messages]);

  const personIcon = React.useMemo(() => (
    <PersonIcon
      className={iconClass}
      info={props.name ? props.name + " (" + props.sender + ")" : props.sender}
      initials={prepareInitials(props.initials, props.sender)}
      owner={props.owner}
      number={props.sender}
      name={props.name}
      message_context_link={"/thread/" + props.thread_id + "?view_as=" + props.sender}
      message_id={props.messages && props.messages[0] ? props.messages[0].message_id : null}
      onViewAsChange={props.onViewAsChange}
    />
  ), [iconClass, props.name, props.sender, props.initials, props.owner, props.thread_id, props.messages, props.onViewAsChange]);

  return (
    <Grid
      container
      direction="column"
    >
      <div className="dtheader">{props.date}</div>
      <Grid
        container
        direction="row"
        alignItems="flex-end"
        wrap="nowrap"
        justifyContent={rowJustify}
        spacing={0}
      >
        {props.owner ? null : (
          <Grid item>
            {personIcon}
          </Grid>
        )}
        <Grid item>
          <MessageBubbles className={messageClass} messageTexts={messageList}/>
        </Grid>
        {props.owner ? (
          <Grid item >
            {personIcon}
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
});

export default MessageGroup;
